export const ROLE_USER = 0;
export const ROLE_RENTER = 5;
export const ROLE_ADMIN = 10;



// WEBPACK FOOTER //
// ./src/constants/roles.js